/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { MPIStrictHttpResponse } from '../../mpi-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TenantConfig } from '../../models/tenant-config';

export interface AdminTenantTenantConfigIdGet$Params {
  tenantConfigId: string;
}

export function adminTenantTenantConfigIdGet(http: HttpClient, rootUrl: string, params: AdminTenantTenantConfigIdGet$Params, context?: HttpContext): Observable<MPIStrictHttpResponse<TenantConfig>> {
  const rb = new RequestBuilder(rootUrl, adminTenantTenantConfigIdGet.PATH, 'get');
  if (params) {
    rb.path('tenantConfigId', params.tenantConfigId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as MPIStrictHttpResponse<TenantConfig>;
    })
  );
}

adminTenantTenantConfigIdGet.PATH = '/Admin/tenant/{tenantConfigId}';
